/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { Typography, Box, CircularProgress } from '@material-ui/core';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { FormsyText } from 'formsy-material-ui/lib';
import { refSetter } from '../../../../utils/helpers';
import globals from '../../../../globals/communityGlobals';
import { textFieldStyle, common, multiLineText } from '../../../../theme/AllocateBaseTheme';
import ApiSelector from '../../../../containers/common/selectors/selectorContainer';
import AutocompleteWrapper from '../../../../components/common/Autocomplete/AutocompleteWrapper';
import { teamsEndpoint, cliniciansEndpoint, nonPatientActiviesTypesEndpoint } from '../../../../settings/constants';

const locale = globals.getArea('nonPatientActivities');
const errorsLocale = globals.getArea('error');

export const actionTypes = {
  create: 'CREATE',
  edit: 'EDIT',
};

export const selectionTypes = {
  teams: 'teams',
  clinician: 'clinician',
};

export const selectionNPATravelTypes = {
  npaWithTravel: 'npaWithTravel',
  npaWithoutTravel: 'npaWithoutTravel',
};

class NonPatientActivityDetails extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectionNPATravelType.bind(this);
    this.handleExcludedClinicians.bind(this);
    this.state = {
      canSubmit: false,
      selectionType:
        this.props.values.clinicianIds && this.props.values.clinicianIds.length
          ? selectionTypes.clinician
          : selectionTypes.teams,
      teamIds: this.props.values.actionType === 'EDIT' ? this.props.values.orgUnitIds.map(({ id }) => id) : [],
      assignedClinicians: [],
      assignedCliniciansData: [],
      clinicianOptionsByOrgUnit: [],
      isCliniciansFilteringByOrgUnitRequired: true,
    };
  }

  setRef = refSetter.bind(this);

  getAssignedClinicianByOrgUnit = () => {
    const { values } = this.props;
    const { teamIds, isCliniciansFilteringByOrgUnitRequired, assignedCliniciansData } = this.state;

    if (isCliniciansFilteringByOrgUnitRequired) {
      if (assignedCliniciansData.length > 0)
        this.setState({
          clinicianOptionsByOrgUnit: [],
          isCliniciansFilteringByOrgUnitRequired: false,
          assignedClinicians: [],
          assignedCliniciansData: [],
        });

      const clinicianOptionsByOrgUnit =
        teamIds.length > 0
          ? values.clinicianOptions.filter(({ orgUnitIds }) =>
              orgUnitIds !== undefined ? teamIds.some(teamId => orgUnitIds.includes(teamId)) : false,
            )
          : [];

      let assignedClinicians = clinicianOptionsByOrgUnit.filter(cli => values.assignedTo.includes(cli.name));

      if (assignedClinicians.length !== values.assignedTo.length) {
        assignedClinicians = values.clinicianOptions.filter(cli => values.assignedToIds.includes(cli.id));
      }

      if (clinicianOptionsByOrgUnit.length > 0)
        this.setState({
          clinicianOptionsByOrgUnit,
          isCliniciansFilteringByOrgUnitRequired: false,
          assignedClinicians,
          assignedCliniciansData: assignedClinicians,
        });

      return assignedClinicians;
    }
    return assignedCliniciansData;
  };

  handleExcludedClinicians = (event, assignedClinicians) => {
    const { values } = this.props;
    const { clinicianOptionsByOrgUnit } = this.state;
    this.setState({ assignedClinicians });

    const excludedClinicians = clinicianOptionsByOrgUnit.filter(
      clinician => !assignedClinicians.some(({ id }) => id === clinician.id),
    );

    let excludedCliniciansId = excludedClinicians.map(x => x.id);
    if (assignedClinicians.length !== values.assignedTo.length) {
      const assignedClinicianIds = assignedClinicians.map(x => x.id);
      excludedCliniciansId = values.assignedToIds.filter(x => !assignedClinicianIds.includes(x));
    }

    this.props.setExcludedClinicians({ excludedCliniciansId });
  };

  handleSelectionTypeSwitch = (event, value) => {
    this.setState({
      selectionType: value,
    });
  };

  handleTeamChange = (event, key, newteams) => {
    this.setState({ teamIds: newteams || [], isCliniciansFilteringByOrgUnitRequired: true });
  };

  handleSelectionNPATravelType = (event, value) => {
    this.props.setStateOfNPATravelType(value);
  };

  render() {
    const { readOnly, innerRef, values, setValidity, shouldAssignToday } = this.props;
    const { selectionType, assignedClinicians } = this.state;
    const isEdit = values.actionType === 'EDIT';
    const errorMessages = {
      maxLength: errorsLocale.getMsg('validationMaxLength', ['500']),
    };

    return (
      <div>
        <Box display="flex" flexDirection="column">
          <Box p={1} flexGrow={1}>
            <Typography variant="h6">{locale.getMsg('activityDetails')}</Typography>
          </Box>
          <Box p={1}>
            <RadioButtonGroup
              className="row"
              style={{ flexDirection: 'column', width: '250px', marginLeft: 0 }}
              name="selectionNPATravelType"
              defaultSelected={selectionNPATravelTypes.npaWithTravel}
              onChange={this.handleSelectionNPATravelType}
              valueSelected={values.selectionNPATravelType}
            >
              <RadioButton
                value={selectionNPATravelTypes.npaWithTravel}
                label={locale.getMsg('npaWithTravel')}
                disabled={isEdit}
                style={{ marginBottom: '5px' }}
              />
              <RadioButton
                value={selectionNPATravelTypes.npaWithoutTravel}
                label={locale.getMsg('npaWithoutTravel')}
                disabled={isEdit}
                style={{ marginBottom: '5px' }}
              />
            </RadioButtonGroup>
          </Box>
          <hr />
          <Box p={1}>
            <RadioButtonGroup
              className="row"
              style={{ flexDirection: 'column', width: '250px', marginLeft: 0 }}
              name="selectionType"
              defaultSelected={selectionTypes.teams}
              onChange={this.handleSelectionTypeSwitch}
              valueSelected={selectionType}
            >
              <RadioButton
                value={selectionTypes.teams}
                label={locale.getMsg('teams')}
                disabled={readOnly}
                style={{ marginBottom: '5px' }}
              />
              <RadioButton
                value={selectionTypes.clinician}
                label={locale.getMsg('clinicians')}
                disabled={readOnly}
                style={{ marginBottom: '5px' }}
              />
            </RadioButtonGroup>
          </Box>
        </Box>

        <Formsy.Form
          onValidSubmit={this.submit}
          onValid={setValidity(true)}
          onInvalid={setValidity(false)}
          onSubmit={this.save}
          ref={innerRef}
        >
          <Box display="flex">
            <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
              {selectionType === selectionTypes.teams ? (
                <ApiSelector
                  reduxIdentifier="teams"
                  endpoint={teamsEndpoint}
                  required
                  multiple
                  floatingLabelText={`${locale.getMsg('teams')}*`}
                  floatingLabelStyle={common.floatingLabelStyle}
                  floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                  floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                  underlineStyle={common.underlineStyle}
                  inputStyle={textFieldStyle.inputStyle}
                  name="orgUnitIds"
                  isFetchRequired
                  value={values.orgUnitIds}
                  innerRef={this.setRef('selector')}
                  onChange={this.handleTeamChange}
                  disabled={readOnly}
                />
              ) : (
                <ApiSelector
                  reduxIdentifier="clinicians"
                  endpoint={cliniciansEndpoint}
                  required
                  multiple
                  floatingLabelText={`${locale.getMsg('clinicians')}*`}
                  floatingLabelStyle={common.floatingLabelStyle}
                  floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                  floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                  underlineStyle={common.underlineStyle}
                  inputStyle={textFieldStyle.inputStyle}
                  name="clinicianIds"
                  isFetchRequired
                  value={values.clinicianIds}
                  innerRef={this.setRef('selector')}
                  disabled={readOnly}
                />
              )}
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '33.3%' }}>
              <ApiSelector
                reduxIdentifier="nonPatientActivyType"
                endpoint={nonPatientActiviesTypesEndpoint}
                required
                floatingLabelText={`${locale.getMsg('activityName')}*`}
                floatingLabelStyle={common.floatingLabelStyle}
                floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
                floatingLabelFocusStyle={common.floatingLabelFocusStyle}
                underlineStyle={common.underlineStyle}
                inputStyle={textFieldStyle.inputStyle}
                name="NonPatientActivityTypeId"
                isFetchRequired
                value={{ id: values.nonPatientActivityTypeId }}
                disabled={readOnly}
              />
            </Box>
            <Box p={1} flexGrow={1} style={{ width: '33.3%' }} />
          </Box>
          {isEdit && selectionType === selectionTypes.teams && values.clinicianIds.length === 0 ? (
            values.clinicianOptions.length > 0 ? (
              <Box p={1} style={{ width: '50%', alignItems: 'end' }} display="flex" justifyContent="flex-end">
                <Box p={1} style={{ color: '#03a9f4', fontSize: '15px' }}>{`${locale.getMsg(
                  'assignedClinicians',
                )}`}</Box>
                <Box p={1} width={200} flexGrow={1}>
                  <AutocompleteWrapper
                    fieldKey="assignedCliniciansId"
                    name="assignedCliniciansId"
                    data={this.getAssignedClinicianByOrgUnit()}
                    isMultiple
                    fullWidth
                    limitTags={2}
                    defaultValue={assignedClinicians}
                    onChange={this.handleExcludedClinicians}
                    isCheckbox
                  />
                </Box>
              </Box>
            ) : (
              <CircularProgress />
            )
          ) : (
            <React.Fragment />
          )}
          {!shouldAssignToday && (
            <Box display="flex">
              <Box p={1} flexGrow={1}>
                <FormsyText
                  name="notes"
                  value={values.notes}
                  multiLine
                  fullWidth
                  updateImmediately
                  validations={{ maxLength: 500 }}
                  validationErrors={errorMessages}
                  errorStyle={textFieldStyle.errorStyle}
                  rows={3}
                  rowsMax={3}
                  className="formsytext-css"
                  floatingLabelStyle={textFieldStyle.floatingLabelStyle}
                  floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
                  style={{ ...multiLineText.style, width: '50%' }}
                  inputStyle={multiLineText.inputStyle}
                  underlineStyle={multiLineText.underlineStyle}
                  underlineFocusStyle={multiLineText.underlineFocusStyle}
                  floatingLabelText={locale.getMsg('note')}
                />
              </Box>
            </Box>
          )}
          {shouldAssignToday && (
            <Box display="flex">
              <Box p={1} flexGrow={1}>
                <FormsyText
                  name="notes"
                  value={values.notes}
                  multiLine
                  rowsMax={3}
                  updateImmediately
                  validations={{ maxLength: 500 }}
                  validationErrors={errorMessages}
                  errorStyle={textFieldStyle.errorStyle}
                  style={{ width: '100%' }}
                  floatingLabelText={locale.getMsg('note')}
                  floatingLabelStyle={textFieldStyle.floatingLabelStyle}
                  floatingLabelShrinkStyle={textFieldStyle.floatingLabelShrinkStyle}
                  underlineStyle={multiLineText.underlineStyle}
                  underlineFocusStyle={multiLineText.underlineFocusStyle}
                  inputStyle={multiLineText.inputStyle}
                />
              </Box>
            </Box>
          )}
        </Formsy.Form>
      </div>
    );
  }
}

NonPatientActivityDetails.defaultProps = {
  readOnly: false,
  innerRef: () => {},
  setValidity: () => {},
  shouldAssignToday: false,
};

NonPatientActivityDetails.propTypes = {
  readOnly: PropTypes.bool,
  innerRef: PropTypes.func,
  values: PropTypes.shape({
    notes: PropTypes.string,
    orgUnitIds: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
    clinicianIds: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
    excludedCliniciansId: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
    nonPatientActivityTypeId: PropTypes.number,
  }).isRequired,
  setValidity: PropTypes.func,
  shouldAssignToday: PropTypes.bool,
};

export default NonPatientActivityDetails;
